export default __webpack_public_path__ + "static/media/SFProTextB.228322ec.woff";